<template>
  <v-content class="gb">
    <v-container fluid>
      <v-row align="center" justify="center">
        <v-col cols="12" md="12" class="top-container">
          <v-card
              :loading="status === 'loading'"
              class="fill-width table_theme card-theme custom-container"
          >
            <v-card-title class="title_table medium-font" style="letter-spacing: normal">
              Homeowners
              <v-spacer></v-spacer>
              <v-btn rounded small dark color="#5C6BC0"
                  style="width: 130px !important; margin-right: 8px; text-transform: none; font-weight: 600;"
                  @click="$router.push('/owner/signup-sources')"
              ><svg width="14" height="14" viewBox="0 0 24 24" fill="none" style="margin-right: 5px;"><path d="M3.9 12c0-1.71 1.39-3.1 3.1-3.1h4V7H7c-2.76 0-5 2.24-5 5s2.24 5 5 5h4v-1.9H7c-1.71 0-3.1-1.39-3.1-3.1zM8 13h8v-2H8v2zm9-6h-4v1.9h4c1.71 0 3.1 1.39 3.1 3.1s-1.39 3.1-3.1 3.1h-4V17h4c2.76 0 5-2.24 5-5s-2.24-5-5-5z" fill="white"/></svg>Links</v-btn>
              <div
                  class="custom-o-search-bar"
              >
                <v-text-field
                    v-model="search"
                    placeholder="Search..."
                    single-line
                    hide-details
                    class="input_search"
                    color="#198beb"
                >
                  <img
                      :src="require('@/assets/img/search.svg')"
                      slot="prepend"
                      alt="help"
                      class="info-tooltip"
                  />
                </v-text-field>
              </div>
<!--              <v-btn text class="custom-o-sliders">-->
<!--                <img :src="require('@/assets/img/settings.svg')" alt/>-->
<!--              </v-btn>-->
            </v-card-title>
            <v-divider class="ma-0 list-divider"></v-divider>
            <div class="status-stats-bar">
              <div class="status-stats-bar__item">
                <span class="status-stats-bar__label">Total</span>
                <span class="status-stats-bar__count">{{ statusCounts.reduce((s, i) => s + i.count, 0) }}</span>
              </div>
              <template v-if="user && user.user_role === 'super_user'">
                <div class="status-stats-bar__divider"></div>
                <div class="status-stats-bar__item" title="Unique people (deduped by owner_id) across tenants">
                  <span class="status-stats-bar__label">Unique</span>
                  <span class="status-stats-bar__count">{{ uniqueOwnerCount }}</span>
                </div>
              </template>
              <div v-if="statusCounts.length > 0" class="status-stats-bar__divider"></div>
              <template v-for="(item, index) in statusCounts">
                <div v-if="index > 0" :key="'divider-' + item.status" class="status-stats-bar__divider"></div>
                <div
                    :key="item.status"
                    class="status-stats-bar__item"
                    :class="{ 'status-stats-bar__item--active': filters.status === item.status }"
                    @click="toggleStatusFilter(item.status)"
                    style="cursor: pointer;"
                >
                  <v-icon class="status-stats-bar__dot" :style="{ color: statusColor(item.status) }">brightness_1</v-icon>
                  <span class="status-stats-bar__label">{{ item.status }}</span>
                  <span class="status-stats-bar__count">{{ item.count }}</span>
                </div>
              </template>
              <div v-if="allSourceValues.length > 0" class="status-stats-bar__divider"></div>
              <div v-if="allSourceValues.length > 0" style="display: flex; align-items: center; gap: 6px; flex-wrap: wrap;">
                <select v-model="sourceFilterValue" @change="onSourceFilterChange" style="height: 28px; border: 1px solid #D9E1F0; border-radius: 6px; padding: 0 6px; font-size: 11px; color: #14213D; outline: none; cursor: pointer; min-width: 110px;">
                  <option value="">All sources</option>
                  <option v-for="s in allSourceValues" :key="s" :value="s">{{ sourceOptionLabel(s) }}</option>
                </select>
                <span v-for="s in sourceFilter" :key="s" style="display: inline-flex; align-items: center; gap: 3px; background: #EEF4FF; color: #2F6FED; font-size: 10px; font-weight: 600; padding: 2px 6px; border-radius: 4px;">
                  {{ sourceOptionLabel(s) }}
                  <span @click="removeSourceFilter(s)" style="cursor: pointer; font-size: 13px; line-height: 1;">&times;</span>
                </span>
              </div>
              <div class="status-stats-bar__actions">
                <v-btn rounded text color="#29ABE2"
                    class="btn-blanco table_btn custom-o-white btn-border action-btn-width"
                    :disabled="allSelectedInactive"
                    @click="show_DeleteModal"
                >Delete</v-btn>
                <v-btn rounded text color="#29ABE2"
                    class="btn-blanco table_btn custom-o-white btn-border action-btn-width"
                    style="text-transform: none;"
                    :href="rutaExel + '&order_by='+ orderBy +'&sort_by='+ sort_by"
                    :disabled="selected.length === 0"
                >Download (excel)</v-btn>
              </div>
            </div>
            <template v-if="error">
              <div>
                <v-alert type="error" dense dismissible @input="error = false">{{ message_error }}</v-alert>
              </div>

            </template>
            <v-data-table
                v-model="selected"
                :headers="showHeaders"
                :items="filteredItems"
                :search="search"
                :custom-filter="searchFilter"
                color="#717e91"
                :multi-sort="false"
                item-key="id"
                show-select
                :options.sync="options"
                :custom-sort="customSort"
                class="clients-table"
                :mobile-breakpoint="0"
            >
              <template v-slot:header.data-table-select="{ props, on }">
                <SelectCheckbox
                    :value="props.value"
                    :indeterminate="props.indeterminate"
                    @input="on.input($event)"
                />
              </template>
              <template v-slot:item.data-table-select="{ isSelected, select }">
                <SelectCheckbox
                    :value="isSelected"
                    @input="select($event)"
                />
              </template>
              <template v-slot:no-data>
                <div style="padding: 24px; text-align: center; color: #717e91; font-size: 13px;">
                  <span v-if="deletedCount > 0 && filters.status !== 'Deleted'">{{ deletedCount }} deleted user(s) are hidden — click Deleted above to view.</span>
                  <span v-else>No users found.</span>
                </div>
              </template>
              <!-- buttons moved to status-stats-bar -->
              <template v-slot:item.name="{ item }">
                <div class="homeowner-cell">
                  <div class="homeowner-cell__name" :title="item.name">{{ item.name }}</div>
                  <div v-if="item.email" class="homeowner-cell__email" :title="item.email">{{ item.email }}</div>
                </div>
              </template>
              <template v-slot:item.address="{ item }">
                <span v-if="item.address" :title="item.address" class="text-truncate-cell">{{ item.address }}</span>
                <span v-else class="address-empty">—</span>
              </template>
              <template v-slot:item.email="{ item }">
                <span :title="item.email" class="text-truncate-cell">{{ item.email }}</span>
              </template>
              <template v-slot:item.phone="{ item }">
                <span>{{ item.phone }}</span>
              </template>
              <template v-slot:item.actions="{ item }">
                <v-btn
                    depressed
                    @click="openEditModal(item)"
                    style="padding: 0; font-size: 11px; height: 24px; min-width: 44px; color: #061D47; border: 1px solid #061D47;"
                >Edit
                </v-btn>
              </template>
              <template v-slot:item.AssignedAgent="{ item }">
                <span :title=item.AssignedAgent>
                  {{ item.AssignedAgent }}
                </span>
              </template>
              <template v-slot:item.status="{ item }">
                <span
                    class="text-xs-right table-f"
                    style="text-transform: capitalize; width: 100% !important; display: inline-block !important; font-size: 11px; white-space: nowrap;"
                >
                  <v-icon
                      class="status-icon custom-status-icon"
                      v-bind:style="{
                      color: statusColor(item.status),
                      fontSize: '8px'
                    }"
                  >brightness_1</v-icon>
                  {{ item.status }}
                </span>
              </template>
              <template v-slot:item.created_at="{ item }">
                <span class="table-f" style="font-size: 12px !important;">{{ formatRegisteredDate(item.created_at) }}</span>
              </template>
              <template v-slot:item.url="{ item }">
                <span
                    class="group d-flex align-center table-f justify-end"
                    style="width: 100% !important;"
                >
                  {{ item.url }}
                  <v-btn
                      text
                      color="#717e91"
                      style="padding:0!important;min-width: 34px;padding-left:5px !important;"
                  >
                    <v-icon class="rota-horizontal">content_copy</v-icon>
                  </v-btn>
                </span>
              </template>
              <template v-slot:item.signup_source="{ item }">
                <!-- Self-reported answer is the useful line for an agent
                     ("Friend/Family", "My Real Estate Agent", etc.). UTM
                     source is machine-detected attribution — show it only
                     when it's a real campaign, not the "direct" fallback
                     that just means "no campaign link was clicked." -->
                <div v-if="item.signup_heard_from || hasRealUtmSource(item.signup_source)">
                  <!-- Primary: self-reported answer, else the UTM campaign
                       if that's all we have (legacy clients). Same styling
                       across both so one line looks the same regardless of
                       which field is populated. -->
                  <div v-if="item.signup_heard_from" style="display: flex; align-items: center; gap: 4px;" title="Self-reported by the client on sign-up">
                    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" style="flex-shrink: 0;"><path d="M20 2H4C2.9 2 2 2.9 2 4v18l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zM6 9h12v2H6V9zm8 5H6v-2h8v2zm4-6H6V6h12v2z" fill="#2F6FED"/></svg>
                    <span style="text-transform: capitalize;">{{ displaySourceName(item.signup_heard_from) }}</span>
                  </div>
                  <div v-else style="display: flex; align-items: center; gap: 4px;" title="Arrived through a campaign link">
                    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" style="flex-shrink: 0;"><path d="M3.9 12c0-1.71 1.39-3.1 3.1-3.1h4V7H7c-2.76 0-5 2.24-5 5s2.24 5 5 5h4v-1.9H7c-1.71 0-3.1-1.39-3.1-3.1zM8 13h8v-2H8v2zm9-6h-4v1.9h4c1.71 0 3.1 1.39 3.1 3.1s-1.39 3.1-3.1 3.1h-4V17h4c2.76 0 5-2.24 5-5s-2.24-5-5-5z" fill="#2F6FED"/></svg>
                    <span style="text-transform: capitalize;">{{ displaySourceName(item.signup_source) }}</span>
                  </div>
                  <!-- Secondary: campaign line, shown under the self-reported
                       answer when we have both. Same font-size and weight as
                       the primary — only difference is a muted color so the
                       two roles are visually distinct without one looking
                       "less important." -->
                  <div v-if="item.signup_heard_from && hasRealUtmSource(item.signup_source)" style="display: flex; align-items: center; gap: 4px; margin-top: 2px; color: #6B7280;" title="Arrived through a campaign link">
                    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" style="flex-shrink: 0;"><path d="M3.9 12c0-1.71 1.39-3.1 3.1-3.1h4V7H7c-2.76 0-5 2.24-5 5s2.24 5 5 5h4v-1.9H7c-1.71 0-3.1-1.39-3.1-3.1zM8 13h8v-2H8v2zm9-6h-4v1.9h4c1.71 0 3.1 1.39 3.1 3.1s-1.39 3.1-3.1 3.1h-4V17h4c2.76 0 5-2.24 5-5s-2.24-5-5-5z" fill="#6B7280"/></svg>
                    <span style="text-transform: capitalize;">{{ displaySourceName(item.signup_source) }}</span>
                  </div>
                </div>
                <span v-else>—</span>
              </template>
              <template v-slot:item.vendor_inquiries="{ item }">
                <div style="text-align: center;">
                  <a
                    v-if="item.vendor_inquiries > 0"
                    href="#"
                    @click.prevent="showConnections(item)"
                    style="color: #29ABE2; text-decoration: none; cursor: pointer;"
                  >{{ item.vendor_inquiries }}</a>
                  <span v-else>{{ item.vendor_inquiries }}</span>
                </div>
              </template>
              <template v-slot:header.notifications="{ header }">
                <span style="cursor: pointer; user-select: none;" @click="toggleAlertsFilter" :title="filters.alerts === null ? 'Click to filter alerts' : filters.alerts ? 'Showing: Alerts ON (click for OFF)' : 'Showing: Alerts OFF (click to clear)'">
                  {{ header.text }}
                  <v-icon x-small v-if="filters.alerts === true" color="#2e7d32">notifications_active</v-icon>
                  <v-icon x-small v-if="filters.alerts === false" color="#b0bec5">notifications_off</v-icon>
                </span>
              </template>
              <template v-slot:item.notifications="{ item }">
                <div style="text-align: center;">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon small v-bind="attrs" v-on="on" :color="notificationStatusDisplay(item).color">
                        {{ notificationStatusDisplay(item).icon }}
                      </v-icon>
                    </template>
                    <span>{{ notificationStatusDisplay(item).label }}</span>
                  </v-tooltip>
                </div>
              </template>
              <template v-slot:item.messagesSent="{ item }">
                <div style="text-align: center;">{{ item.messagesSent }}</div>
              </template>
              <template v-slot:item.messagesReceived="{ item }">
                <div style="text-align: center;">{{ item.messagesReceived }}</div>
              </template>
            </v-data-table>

          </v-card>
        </v-col>
      </v-row>
    </v-container>

    <delete-client-modal
        :selected="selected"
        :show="showDeleteModal"
        :hide="hideDeleteClientModal"
        @setter="setter"
    ></delete-client-modal>

    <push-message-modal
        :show="showPushMessageModal"
        :hide="hidePushMessageModal"
        :click="clickPushMessageModal"
    ></push-message-modal>
    <confirm-message-modal
        :show="showConfirmMessageModal"
        :hide="hideConfirmMessageModal"
        :click="clickConfirmMessageModal"
        :cancel="closeConfirmMessageModal"
    ></confirm-message-modal>
    <success-message-modal :show="showSuccessMessageModal" :hide="hideSuccessMessageModal"></success-message-modal>
    <DeleteAllModal
        :show="showDeleteAllModal"
        :hide="hideDeleteAllModal"
    />
    <connections-modal
        ref="connectionsModal"
        :title="connectionsUser ? 'Vendor Inquiries - ' + connectionsUser.name : ''"
        :referrals="parsedReferrals"
        :ownerId="connectionsUser ? connectionsUser.owner_id : ''"
    />
    <edit-user-modal
        :show="showEditModal"
        :user="selectedUser"
        :hide="closeEditModal"
    />
  </v-content>
</template>

<script>
  import deleteClientModal from "./modals/delete-client";
  import DeleteAllModal from "@/views//modals/delete-all";
  import connectionsModal from "@/views/modals/connections";
  import EditUserModal from "@/views/owner/modals/EditUserModal";
  import pushMessageModal from "./modals/push-message";
  import confirmMessageModal from "./modals/confirm-message";
  import successMessageModal from "./modals/success-message";
  import {mapState, mapActions} from "vuex";
  import config from "@/config/constants.js";
  import {notificationStatusDisplay} from '@/util/notification_status';
  import {mask} from "vue-the-mask";
  import {firestore} from "@/config/firebase";
  import SelectCheckbox from '@/components/SelectCheckbox.vue';

  let token = localStorage.getItem("auth_token");

  export default {
    name: "clientList",
    async created() {
      this._isDestroyed = false;
      if (this.$store.getters["Authenticate/isLoggedIn"]) {
        const prevRole = this.$store.state.Users_list.userRole;
        if (prevRole && prevRole !== 'client') {
          await this.$store.dispatch('Users_list/clear_data');
        }
        this.$store.dispatch("Users_list/get_tenant", "client").then(response => {
          if (this._isDestroyed) return;
          if (response === 'success') {
            const usersPromise = this.get_users("client");
            this.prefetchReferrals();
            usersPromise.then(() => {
              if (this._isDestroyed) return;
              this.recalcVendorInquiries();
            });
          }
        });
      } else {
        this.$router.push("/owner/sign_up");
      }
    },
    directives: {
      mask,
    },
    computed: {
      ...mapState({
        status: (state) => state.Users_list.status,
        totals: (state) => state.Users_list.totals,
        dataUsers: (state) => state.Users_list.dataUsers,
        user: (state) => state.Authenticate.user,
      }),
      selectedUser() {
        if (!this.selectedUserId) return {};
        return this.dataUsers.find(u => u.owner_id === this.selectedUserId) || {};
      },
      allSourceValues() {
        const sources = new Set();
        for (const u of this.dataUsers) {
          if (u.signup_source) sources.add(u.signup_source);
          if (u.signup_heard_from) sources.add(u.signup_heard_from);
        }
        return Array.from(sources).sort();
      },
      filteredItems() {
        const STATUS_ORDER = { active: 0, onboarding: 1, "signed up": 2, invited: 3, inactive: 4, cancelled: 5, deleted: 6 };
        let items = this.dataUsers;
        if (!this.filters.status) {
          items = items.filter(x => (x.status || '').toLowerCase() !== 'deleted');
        } else {
          items = items.filter(x => this.filters.status.toLowerCase() === (x.status || '').toLowerCase());
        }
        if (this.sourceFilter && this.sourceFilter.length > 0) {
          items = items.filter(x => {
            const vals = [x.signup_source, x.signup_heard_from].filter(Boolean).map(v => v.toLowerCase());
            return this.sourceFilter.some(f => vals.includes(f.toLowerCase()));
          });
        }
        if (this.filters.alerts !== null) {
          items = items.filter(x => {
            const hasAlerts = x.device_tokens && x.device_tokens.length > 0;
            return this.filters.alerts ? hasAlerts : !hasAlerts;
          });
        }
        if (!this.options.sortBy || this.options.sortBy.length === 0) {
          return [...items].sort((a, b) => {
            const aOrder = STATUS_ORDER[(a.status || "").toLowerCase()] ?? Infinity;
            const bOrder = STATUS_ORDER[(b.status || "").toLowerCase()] ?? Infinity;
            if (aOrder !== bOrder) return aOrder - bOrder;
            const aName = (a.name || "").toLowerCase();
            const bName = (b.name || "").toLowerCase();
            return aName < bName ? -1 : aName > bName ? 1 : 0;
          });
        }
        return items;
      },
      showHeaders() {

        const self = this;
        if (self.user.user_role === 'super_user') {
          self.selectedHeaders = ['COMPANY NAME', 'NAME', 'ADDRESS', 'PHONE', 'STATUS', 'REGISTERED', 'AGENT', 'ALERTS', 'IN', 'OUT', 'INQUIRIES', 'ACTIONS'];
        } else {
          self.selectedHeaders = ['NAME', 'ADDRESS', 'PHONE', 'STATUS', 'REGISTERED', 'AGENT', 'SOURCE', 'ALERTS', 'IN', 'OUT', 'INQUIRIES', 'ACTIONS'];
        }
        return self.headers.filter(s => self.selectedHeaders.includes(s.text));
      },
      statusCounts() {
        const PREFERRED_ORDER = ['Active', 'Signed Up', 'Deleted', 'Cancelled'];
        const counts = {};
        for (const user of this.dataUsers) {
          if (user.status) counts[user.status] = (counts[user.status] || 0) + 1;
        }
        const ordered = PREFERRED_ORDER.filter(s => counts[s]);
        const extra = Object.keys(counts).filter(s => !PREFERRED_ORDER.includes(s));
        return [...ordered, ...extra].map(s => ({ status: s, count: counts[s] }));
      },
      uniqueOwnerCount() {
        const ids = new Set();
        for (const u of this.filteredItems) {
          if (u.owner_id) ids.add(u.owner_id);
        }
        return ids.size;
      },
      allSelectedInactive() {
        return this.selected.length === 0 || this.selected.every(u => ['Deleted', 'Cancelled'].includes(u.status));
      },
      deletedCount() {
        return this.dataUsers.filter(u => (u.status || '').toLowerCase() === 'deleted').length;
      }
    },
    props: {
      deleUser: {
        default: false,
      },
      pushNotification: {
        default: false,
      },
      sendPush: {
        default: false,
      },
      confPush: {
        default: false,
      },
    },
    watch: {
      selected(val) {
        const self = this;
        let usersSize = self.dataUsers.length;
        if (val.length > 0) {
          if (val.length === usersSize) {
            self.rutaExel = config.api_url + "download_exel?user_role=client&token=" + token + "&users=all";
          } else {
            let usersIds = val.map(function (user) {
              return user.owner_id;
            })
            self.rutaExel = config.api_url + "download_exel?user_role=client&token=" + token + "&users=" + usersIds;
          }
        } else {
          self.rutaExel = config.api_url + "download_exel?user_role=client&token=" + token;
        }
      }
    },
    data() {
      return {
        statuses: [
          {id: "", name: "All Users"},
          {id: "active", name: "Active Users"},
          {id: "signed up", name: "Signed Up Users"},
          {id: "deleted", name: "Deleted Users"},
          {id: "cancelled", name: "Cancelled Users"}
        ],
        filters: {
          status: "",
          alerts: null,
        },
        showDeleteAllModal: false,
        options: {
          itemsPerPage: 25,
          sortBy: [],
          sortDesc: []
        },
        selected: [],
        showDeleteModal: false,
        showPushMessageModal: false,
        showConfirmMessageModal: false,
        showSuccessMessageModal: false,
        title: "",
        text: "",
        rutaExel:
          config.api_url +
          "download_exel?user_role=client&token=" + token,
        search: "",
        sourceFilter: [],
        sourceFilterValue: "",
        headers: [
          {text: "COMPANY NAME", value: "company_name", sortable: true},
          {text: "NAME", value: "name", sortable: true},
          {text: "ADDRESS", value: "address", sortable: true, width: '220px'},
          {text: "EMAIL", value: "email", sortable: true},
          {text: "PHONE", value: "phone", sortable: true, width: '150px'},
          {text: "STATUS", value: "status", sortable: true, width: '90px'},
          {text: "REGISTERED", value: "created_at", sortable: true, width: '90px'},
          {text: "AGENT", value: "AssignedAgent", sortable: true},
          {text: "SOURCE", value: "signup_source", sortable: true, width: '110px'},
          {text: "ALERTS", value: "notifications", sortable: true, width: '65px', align: 'center', cellClass: 'col-center'},
          {text: "IN", value: "messagesReceived", sortable: true, width: '50px', align: 'center', cellClass: 'col-center'},
          {text: "OUT", value: "messagesSent", sortable: true, width: '50px', align: 'center', cellClass: 'col-center'},
          {text: "INQUIRIES", value: "vendor_inquiries", sortable: true, width: '75px', align: 'center', cellClass: 'col-center'},
          {text: "ACTIONS", value: "actions", sortable: false, width: '70px', align: 'center', cellClass: 'col-center'},
        ],
        selectedHeaders: [],
        orderBy: null,
        sortBy: null,
        mask: "### - ### - ####",
        error: false,
        message_error: null,
        list_agents: [],
        connectionsUser: null,
        parsedReferrals: [],
        showEditModal: false,
        selectedUserId: null,
      };
    },
    components: {
      "delete-client-modal": deleteClientModal,
      "push-message-modal": pushMessageModal,
      "confirm-message-modal": confirmMessageModal,
      "success-message-modal": successMessageModal,
      "connections-modal": connectionsModal,
      "edit-user-modal": EditUserModal,
      DeleteAllModal,
      SelectCheckbox
    },
    methods: {
      notificationStatusDisplay,
      ...mapActions({get_users: "Users_list/get_users"}),
      // Built-in non-link source buckets. Any source NOT in this set is
      // assumed to have come from a link campaign (created on the Links
      // page) and gets the 🔗 link marker in the dropdown + icon in the
      // column. Using lowercase keys for case-insensitive comparison.
      isBuiltInSource(s) {
        const NON_LINK = new Set(['direct', 'real estate agent']);
        return !!s && NON_LINK.has(s.toLowerCase());
      },
      isLinkSource(s) {
        return !!s && !this.isBuiltInSource(s);
      },
      // "direct" is the fallback signup_source used when no UTM link was
      // clicked — it carries no attribution info on its own, so we hide it
      // in the Source column. Any non-"direct" value is a real campaign or
      // channel worth surfacing (agent-link, facebook-ad, real estate agent,
      // etc.). Case-insensitive so "Direct" / "DIRECT" also fall through.
      hasRealUtmSource(s) {
        return !!s && s.toLowerCase() !== 'direct';
      },
      // Display-side rename — "Real Estate Agent" reads as "Agent" in the
      // UI. We don't migrate the stored value so the rename is reversible
      // and doesn't collide with any in-flight agent invite flows.
      displaySourceName(s) {
        if (!s) return '';
        if (s.toLowerCase() === 'real estate agent') return 'Agent';
        return s.charAt(0).toUpperCase() + s.slice(1);
      },
      sourceOptionLabel(s) {
        if (!s) return '';
        const label = this.displaySourceName(s);
        return this.isBuiltInSource(s) ? label : `🔗 ${label}`;
      },
      onSourceFilterChange() {
        if (this.sourceFilterValue && !this.sourceFilter.includes(this.sourceFilterValue)) {
          this.sourceFilter.push(this.sourceFilterValue);
        }
        this.sourceFilterValue = "";
      },
      removeSourceFilter(s) {
        this.sourceFilter = this.sourceFilter.filter(v => v !== s);
      },
      toggleAlertsFilter() {
        if (this.filters.alerts === null) {
          this.filters.alerts = true;
        } else if (this.filters.alerts === true) {
          this.filters.alerts = false;
        } else {
          this.filters.alerts = null;
        }
      },
      toggleStatusFilter(status) {
        this.filters.status = this.filters.status === status ? "" : status;
      },
      prefetchReferrals() {
        if (this.$store.state.Users_list.referralsCache) return;
        const tenantId = this.user.tenant_id;
        firestore
          .collection('tenants').doc(tenantId)
          .collection('referrals')
          .get()
          .then(snapshot => {
            this.$store.state.Users_list.referralsCache = snapshot.docs;
          });
      },
      async recalcVendorInquiries() {
        const tenantId = this.user.tenant_id;
        let docs;
        if (this.$store.state.Users_list.referralsCache) {
          docs = this.$store.state.Users_list.referralsCache;
        } else {
          const snapshot = await firestore
            .collection('tenants').doc(tenantId)
            .collection('referrals')
            .get();
          docs = snapshot.docs;
          this.$store.state.Users_list.referralsCache = docs;
          if (this._isDestroyed) return;
        }
        if (this._isDestroyed) return;
        // Build client lookup from dataUsers (only clients are loaded on this page)
        const clientLookup = {};
        for (const u of this.dataUsers) {
          if (u.user_role === 'client') {
            clientLookup[u.owner_id] = u;
          }
        }
        const parsed = [];
        const vendorsByClient = {};
        for (const doc of docs) {
          const data = doc.data();
          const ids = (data.participant_ids || []).map(p => p.split('/')[4]).filter(Boolean);
          const participants = Array.isArray(data.participants) ? data.participants : [];
          let vendorId = '';
          let vendorName = '';
          let clientId = '';
          let clientName = '';
          for (const uid of ids) {
            if (clientLookup[uid]) {
              clientId = uid;
              const c = clientLookup[uid];
              clientName = c.name || ((c.first_name || '') + ' ' + (c.last_name || '')).trim() || 'Unknown';
            } else {
              // The other participant is the vendor
              vendorId = uid;
              let vp = participants.find(p => p.user_id === uid);
              if (!vp) {
                // AI iOS fast-path historically wrote participant_ids using the vendor's
                // owner_id but participants[].user_id using the tenant doc id, so a strict
                // join can miss. Fall back to the non-client participant.
                vp = participants.find(p => p.user_role && p.user_role !== 'client');
              }
              vendorName = vp ? (vp.company_name || ((vp.first_name || '') + ' ' + (vp.last_name || '')).trim() || 'Unknown') : 'Unknown';
            }
          }
          if (vendorId && clientId) {
            if (!vendorsByClient[clientId]) vendorsByClient[clientId] = new Set();
            vendorsByClient[clientId].add(vendorId);
            parsed.push({
              vendorId, vendorName: vendorName || 'Unknown',
              clientId, clientName: clientName || 'Unknown',
              created_at: data.created_at, is_read: data.is_read,
              ai_generated: data.ai_generated === true
            });
          }
        }
        this.parsedReferrals = parsed;
        // Batch-assign vendor_inquiries without triggering N individual reactivity updates
        for (const user of this.dataUsers) {
          const count = vendorsByClient[user.owner_id] ? vendorsByClient[user.owner_id].size : 0;
          user.vendor_inquiries = count;
        }
        // Single reactivity trigger to refresh computed properties
        this.$store.commit('Users_list/refreshDataUsers');
      },
      showConnections(item) {
        this.connectionsUser = item;
        this.$nextTick(() => this.$refs.connectionsModal.open());
      },
      searchFilter(value, search, item) {
        if (!search) return true;
        const s = search.toLowerCase();
        const str = [item.company_name, item.name, item.email, item.phone, item.status, item.AssignedAgent, item.address].filter(Boolean).join(' ').toLowerCase();
        return str.includes(s);
      },
      formatRegisteredDate(timestamp) {
        if (!timestamp) return '';
        const d = new Date(timestamp);
        const m = d.getMonth() + 1;
        const day = String(d.getDate()).padStart(2, '0');
        const y = String(d.getFullYear()).slice(-2);
        return `${m}/${day}/${y}`;
      },
      statusColor(status) {
        let color = "";
        switch (status) {
          case "Active": {
            color = "#12d120";
            break;
          }
          case "Invited":
          case "Deleted":
          case "Cancelled":
          case "Onboarding":
          case "Inactive": {
            color = "#717e91";
            break;
          }
        }
        return color;
      },
      setter() {
        const self = this;
        self.selected = [];
      },
      show_DeleteModal() {
        this.showDeleteModal = true;
      },
      hideDeleteAllModal() {
        this.showDeleteAllModal = false;
      },
      hideDeleteClientModal() {
        this.showDeleteModal = false;
      },
      hidePushMessageModal() {
        this.showPushMessageModal = false;
      },
      hideConfirmMessageModal() {
        this.showConfirmMessageModal = false;
        this.showPushMessageModal = true;
      },
      closeConfirmMessageModal() {
        this.showConfirmMessageModal = false;
        this.showPushMessageModal = true;
      },
      hideSuccessMessageModal() {
        this.showSuccessMessageModal = false;
      },

      clickPushMessageModal() {
        this.showConfirmMessageModal = true;
        this.showPushMessageModal = true;
      },
      clickConfirmMessageModal() {
        this.showPushMessageModal = false;
        this.showConfirmMessageModal = false;

        this.$store.dispatch("Push_notifications/send_notification").then(response => {
          if (response === 'success') {
            this.showSuccessMessageModal = true;
          }
        });
      },
      get_excel(user_role) {
        const self = this;
        self.$store
          .dispatch("Users_list/download", user_role);
      },
      customSort(items, index, isDescending) {
        this.orderBy = index[0];
        this.sort_by = (isDescending[0]) ? 'desc' : 'asc';

        const STATUS_ORDER = { active: 0, onboarding: 1, "signed up": 2, invited: 3, inactive: 4, cancelled: 5, deleted: 6 };

        // Firestore Timestamps stringify to "[object Object]"; route them through
        // their numeric ms value so the first sort click actually orders them.
        const toMillisOrNull = (v) => {
          if (v == null) return null;
          if (typeof v.toMillis === 'function') return v.toMillis();
          if (v instanceof Date) return v.getTime();
          if (typeof v === 'object' && typeof v.seconds === 'number') return v.seconds * 1000 + Math.floor((v.nanoseconds || 0) / 1e6);
          return null;
        };

        return items.sort((a, b) => {
          const col = index[0];
          if (col === "status") {
            const aOrder = STATUS_ORDER[(a.status || "").toLowerCase()] ?? Infinity;
            const bOrder = STATUS_ORDER[(b.status || "").toLowerCase()] ?? Infinity;
            if (aOrder !== bOrder) return isDescending[0] ? aOrder - bOrder : bOrder - aOrder;
            const aCompany = (a.company_name || "").toLowerCase();
            const bCompany = (b.company_name || "").toLowerCase();
            if (aCompany !== bCompany) return aCompany < bCompany ? -1 : 1;
            const aName = (a.name || "").toLowerCase();
            const bName = (b.name || "").toLowerCase();
            return aName < bName ? -1 : aName > bName ? 1 : 0;
          }
          // Generic sort for all other columns
          let aVal = a[col] ?? '';
          let bVal = b[col] ?? '';
          const aMs = toMillisOrNull(aVal);
          const bMs = toMillisOrNull(bVal);
          if (aMs !== null || bMs !== null) {
            const aN = aMs ?? -Infinity;
            const bN = bMs ?? -Infinity;
            if (aN === bN) return 0;
            return isDescending[0] ? (aN < bN ? 1 : -1) : (aN < bN ? -1 : 1);
          }
          if (typeof aVal === 'number' || typeof bVal === 'number') {
            aVal = Number(aVal) || 0;
            bVal = Number(bVal) || 0;
          } else {
            aVal = String(aVal).toLowerCase();
            bVal = String(bVal).toLowerCase();
          }
          if (aVal === bVal) return 0;
          if (isDescending[0]) {
            return aVal < bVal ? 1 : -1;
          } else {
            return aVal < bVal ? -1 : 1;
          }
        });
      },
      openEditModal(item) {
        this.selectedUserId = item.owner_id;
        this.showEditModal = true;
      },
      closeEditModal() {
        this.showEditModal = false;
      },
    },
    beforeDestroy() {
      this._isDestroyed = true;
    }
  };
</script>

<style scoped>
  .status-stats-bar {
    display: flex;
    align-items: center;
    padding: 10px 24px;
    margin-bottom: 8px;
    background-color: #f8f9fb;
    border-bottom: 1px solid #e8ebef;
  }

  .status-stats-bar__divider {
    width: 1px;
    height: 20px;
    background-color: #d0d5dd;
    margin: 0 20px;
    flex-shrink: 0;
  }

  .status-stats-bar__item {
    display: flex;
    align-items: center;
    gap: 6px;
  }

  .status-stats-bar__item--active {
    background: #E3F2FD;
    border-radius: 6px;
    padding: 2px 8px;
  }

  .status-stats-bar__dot {
    font-size: 8px !important;
  }

  .status-stats-bar__label {
    color: #717e91;
    font-size: 13px;
    font-weight: 500;
  }

  .status-stats-bar__count {
    color: #29ABE2;
    font-size: 13px;
    font-weight: 600;
  }

  .status-stats-bar__actions {
    margin-left: auto;
    display: flex;
    align-items: center;
    gap: 8px;
  }

  .list-divider {
    max-width: 1380px;
    margin-left: 13px !important;
  }

  .custom-container {
    top: 40px;
    max-width: 1500px !important;
    min-height: 557px;
    margin-bottom: 50px !important;
  }

  .custom-o-white {
    height: 32px !important;
    top: 2px;
  }

  .action-btn-width {
    width: 149px;
  }

  .top-container {
    margin-top: 0px;
  }

  .table_btn {
    color: #2bace2;
    font-size: 13px;
    font-weight: 400;
    text-transform: capitalize;
    letter-spacing: normal;
  }

  .table_botonera {
    padding: 15px 16px 20px;
    position: relative;
  }

  .fill-width .mar_table {
    margin: 0 13px;
  }

  .input_field_phone_number {
    padding: 0;
  }

  /* ---- Responsive ---- */
  @media (max-width: 1100px) {
    .status-stats-bar {
      flex-wrap: wrap;
      gap: 6px 12px;
      padding: 8px 12px;
    }

    .status-stats-bar__divider { display: none; }

    .status-stats-bar__actions {
      width: 100%;
      margin-left: 0;
      margin-top: 8px;
      flex-wrap: wrap;
      gap: 6px;
    }

    .action-btn-width {
      width: 149px;
    }

    .custom-container {
      min-height: auto !important;
    }
  }

  @media (max-width: 600px) {
    .status-stats-bar {
      padding: 6px 8px;
      gap: 4px 8px;
    }

    .status-stats-bar__label { font-size: 11px; }
    .status-stats-bar__count { font-size: 11px; }

    .status-stats-bar__actions {
      gap: 4px;
    }

    .status-stats-bar__actions {
      display: flex;
      justify-content: center;
    }

    .status-stats-bar__actions .v-btn {
      width: 130px !important;
      min-width: 0 !important;
      font-size: 11px !important;
      padding: 0 8px !important;
      height: 28px !important;
      letter-spacing: 0 !important;
    }
  }
</style>

<style lang="scss">
  .clients-table {
    .v-data-footer { border-top: none !important; }

    table {
      margin: 0 13px;
      max-width: 1380px;
      table-layout: fixed;
      width: 100%;
    }

    thead tr th {
      height: 48px !important;
      font-size: 11px !important;
      font-weight: 700 !important;
      text-transform: uppercase;
      font-family: Roboto, sans-serif !important;
      color: #979797 !important;
      white-space: nowrap;
      border-bottom: none !important;
      padding: 0 8px !important;

      .v-data-table-header__icon {
        color: #29ABE2 !important;
        margin-left: 2px;
        font-size: 14px !important;
        opacity: 0 !important;
        display: inline-block !important;
        vertical-align: middle;
      }

      &.active .v-data-table-header__icon {
        opacity: 1 !important;
      }

      span {
        position: static !important;
        top: auto !important;
        padding-right: 0 !important;
        line-height: normal !important;
        display: inline !important;
      }
    }

    tbody tr {
      box-shadow: inset 0 1px 0 rgba(0,0,0,0.08) !important;

      td {
        height: 56px !important;
        font-size: 13px;
        font-weight: 400;
        padding: 0 8px !important;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;

      }
    }

    th.text-center {
      text-align: center !important;
    }
    td.col-center {
      text-align: center !important;
      overflow: visible !important;
    }

    th:first-child, td:first-child {
      width: 48px !important;
      max-width: 48px !important;
    }
  }

  .text-truncate-cell {
    display: block;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  /* Two-line homeowner cell: full name (wraps, never truncates) + muted email */
  .clients-table .homeowner-cell {
    padding: 4px 0;
    line-height: 1.3;
  }
  .clients-table .homeowner-cell__name {
    font-size: 13px;
    font-weight: 500;
    color: #14213D;
    white-space: normal;
    word-break: break-word;
  }
  .clients-table .homeowner-cell__email {
    font-size: 11px;
    color: #717e91;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .clients-table .address-empty {
    color: #b0bec5;
  }

  /* ---- Responsive table ---- */
  @media (max-width: 1100px) {
    .clients-table {
      .v-data-table__wrapper {
        overflow-x: auto;
        -webkit-overflow-scrolling: touch;
      }

      table {
        table-layout: auto !important;
        min-width: 1100px;
      }
    }

    .v-card__title {
      flex-wrap: wrap !important;
      gap: 8px;

      .v-spacer { flex: 0 0 0 !important; }
    }

    .custom-o-search-bar {
      position: relative !important;
      right: 0 !important;
      left: 0 !important;
    }
  }

  @media (max-width: 600px) {
    .v-card__title {
      flex-direction: column !important;
      align-items: flex-start !important;

      .v-spacer { display: none; }
    }

    .custom-o-search-bar {
      width: 100% !important;
      max-width: 300px !important;
    }

    .clients-table table {
      min-width: 950px;
    }
  }
</style>
